export enum CreativeTagEvent {
  CreativeInit = 'creativeInit',
  CreativeRequested = 'creativeRequested',
  CreativeLoaded = 'creativeLoaded',
  CreativeLoadingFailed = 'creativeLoadingFailed',
  CreativeRenderingError = 'creativeRenderingError',
  CreativeAssetLoad = 'creativeAssetLoad',
  CreativeDisplay = 'creativeDisplay',
  CreativeView = 'creativeView',
  CreativeTimespent = 'creativeTimespent',
  CreativeShow = 'creativeShow',
  CreativeClicked = 'creativeClicked',
  CreativeEngagement = 'creativeEngagement',
  CreativeDirectionClick = 'creativeDirectionClick',
  CreativeInteraction = 'creativeInteraction',
  CreativeMapActivation = 'creativeMapActivation',
  CreativePinClick = 'creativePinClick',

  CreativeReached = 'creativeReached',
  CreativeCompleted = 'creativeCompleted',
  CreativeChapterViewed = 'creativeChapterViewed',
  CreativeNavigationSlide = 'creativeNavigationSlide',
  CreativeNavigationSiteScroller = 'creativeNavigationSiteScroller',
  CreativeRedirection = 'creativeRedirection',

  // Meta DSP DoubleVerify/IAS verification-script lifecycle (SPY-16443). Emitted
  // by the verification logging helper to trace, per impression/domain, whether
  // each vendor's script is injected, loads, or errors. One distinct event per
  // vendor/status for querying.
  MetaDspDvInjected = 'metaDspDvInjected',
  MetaDspDvLoaded = 'metaDspDvLoaded',
  MetaDspDvError = 'metaDspDvError',
  MetaDspIasInjected = 'metaDspIasInjected',
  MetaDspIasLoaded = 'metaDspIasLoaded',
  MetaDspIasError = 'metaDspIasError',
  // Measurement-pixel fire (Resource Timing): DV `tpsc-*.doubleverify.com`,
  // IAS `dt.adsafeprotected.com` (SPY-16522). Distinct from script load.
  MetaDspDvVendorRequest = 'metaDspDvVendorRequest',
  MetaDspIasVendorRequest = 'metaDspIasVendorRequest',

  MetaDspInitWarning = 'metaDspInitWarning',

  VideoStart = 'videoStart',
  VideoFirstQuartile = 'videoFirstQuartile',
  VideoMidpoint = 'videoMidpoint',
  VideoThirdQuartile = 'videoThirdQuartile',
  VideoComplete = 'videoComplete',
  VideoMute = 'videoMute',
  VideoUnmute = 'videoUnmute'
}
